import React, { Component } from 'react';
import RiskAssessmentContent from './RiskAssessmentContent';
import { RuleCategory } from '../../../../services/RuleCategory';

// RuleCategory.RESPONSIBLE_GAMBLING
class ResponsibleGamblingMW extends Component {
    render() {
        return (
            <RiskAssessmentContent
                ruleCategory={RuleCategory.RESPONSIBLE_GAMBLING}
            />
        );
    }
}

export default ResponsibleGamblingMW;
